import {
  activeMembershipOf,
  representativeInheritanceOf,
} from '@e-socna/folder-actors';
import type {
  InheritedMembership,
  InheritingRepresentative,
  RepresentativeInheritance,
} from '@e-socna/folder-actors';

export interface InheritingOrganizationActor {
  readonly thirdPartyId: string;
  readonly representatives?:
    | readonly (InheritingRepresentative<string> &
        Readonly<{ personId: string }>)[]
    | null;
}

export interface OrganizationMemberships {
  readonly _id: string;
  readonly allMemberships: readonly (InheritedMembership<string> &
    Readonly<{ personId: string; statusId: string }>)[];
}

// The roles and types the representatives of an organization actor carry, as the back
// consolidates them: their own ones, else the ones of their active membership.
export const representativeInheritancesOf = (
  { thirdPartyId, representatives }: InheritingOrganizationActor,
  organizations: readonly OrganizationMemberships[],
  enabledStatusId: string,
): readonly RepresentativeInheritance<string>[] => {
  const memberships =
    organizations.find(({ _id }) => _id === thirdPartyId)?.allMemberships ?? [];

  return (representatives ?? []).map((representative) =>
    representativeInheritanceOf(
      representative,
      activeMembershipOf(memberships, representative.personId, enabledStatusId),
    ),
  );
};
